import { render, staticRenderFns } from "./CheckoutAwardsProduct.vue?vue&type=template&id=385b1a30&"
import script from "./CheckoutAwardsProduct.vue?vue&type=script&lang=js&"
export * from "./CheckoutAwardsProduct.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutAwardsProduct.vue?vue&type=style&index=0&id=385b1a30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports